import React from "react";
import BlueTick from "../Icons/BlueTick";
import StarIcon from "../Icons/StarIcon";
import profile2 from "../../images/profile2.jpg";
import profile3 from "../../images/profile3.jpg";
import profile4 from "../../images/profile4.jpg";

import "./LeftBottomDashBoard.css";

export default function LeftBottomDashBoard() {
  return (
    <div className="LeftBottomDashBoard">
      <div className="LeftTopDashBoardHeading">
        <p className="LeftTopDashBoardHeading1">Top Merchant</p>
        <p className="LeftTopDashBoardHeading2">List merchant</p>
      </div>
      <div className="profile-2">
        <img src={profile2} className="profile-photo"></img>
        <div className="profile-name-details">
          <p className="profile-name"> Angikiram Mas Aditi</p>
          <div className="profile-extra-details">
            <p className="profile-city">Outlet terjual</p>
            <p className="profile-comments">(22)</p>
            <StarIcon />
            <p className="profile-rating">5</p>
          </div>
        </div>
        <BlueTick />
      </div>
      <div className="profile-3">
        <img src={profile3} className="profile-photo"></img>
        <div className="profile-name-details">
          <p className="profile-name"> Warang Muba Yanti</p>
          <div className="profile-extra-details">
            <p className="profile-city">Outlet terjual</p>
            <p className="profile-comments">(14)</p>
            <StarIcon />
            <p className="profile-rating">4.9</p>
          </div>
        </div>
        <BlueTick />
      </div>
      <div className="profile-4">
        <img src={profile4} className="profile-photo"></img>
        <div className="profile-name-details">
          <p className="profile-name"> Kapau Anak Sultan</p>
          <div className="profile-extra-details">
            <p className="profile-city">Outlet terjual</p>
            <p className="profile-comments">(14)</p>
            <StarIcon />
            <p className="profile-rating">4.3</p>
          </div>
        </div>
        <BlueTick />
      </div>
    </div>
  );
}
